/*
 * To add a new permission, add it to the Permission enum in libs/shared-backend/src/permissions/permissions.ts,
 * add it to the config so that it will be submitted to SSO and then add it to the enum below.
 * To get the hashed value, run: pnpm shorthash the_new_enum_value
 *
 * Important: Export as const so that the clear names will be stripped from the bundle code
 */

//const enum is important! see above
export const enum HashedPermission {
  // SYSTEM
  SYSTEM_ROOT = "82841ebc",
  TEMP_DISABLED = "temp_disabled_for_now",

  // SOCIAL CLEARANCES
  SOCIAL_CLEARANCES = "4dd6530",
  SOCIAL_CLEARANCES_CREATE = "3d6b262e",

  // STATEMENTS
  STATEMENTS = "78d08953",

  // PAYOUTS
  PAYOUTS = "74bd8b50",

  // ORGS
  ORGS_SETTINGS = "42f4f93",
  ORGS_USERS = "a252de94",
  ORGS_USERS_INVITE = "87c35267",

  // LICENSES
  LICENSES = "37b0d78d",
  LICENSES_COMMERCIAL = "607fd76b",
  LICENSES_LIBRARY_ALL = "e5041973",

  // COMMERCIAL SUPPLY CHAIN
  COMMERCIAL_SUPPLY_CHAIN = "b3ba60c7",

  // MUSIC
  MUSIC = "a8d6d04",
  MUSIC_ADAPTIVE_MUSIC = "d25de68",
  MUSIC_COMMERCIAL_MUSIC = "90bd830e",
  MUSIC_DOWNLOADS = "e5530219",
  MUSIC_CHARTS = "ebf9c1e1",
  MUSIC_BRIEF_SEARCH = "78ba16a7",
  MUSIC_SOUND_EFFECTS_TAB = "d05550ae",
  MUSIC_NATURAL_LANGUAGE_TOGGLE = "564e32ef",

  // MEASUREMENT
  MEASUREMENT = "c6971f2f",

  // DEMO
  DEMO = "7c72e006",

  // RESOURCES
  RESOURCES = "bdd3977c",

  // CUSTOMER SUPPORT
  CUSTOMER_SUPPORT = "3f08c4c3",

  // HELP CENTER
  HELP_CENTER = "949276f2",

  // LABS
  LABS_DEVELOPER = "328c215",
  LABS_ADMIN = "e7352f4c",

  // MUSIC INGESTION
  MUSIC_INGESTION_ACCESS = "df5e62b0",

  //LEGAL
  LEGAL_ADMIN = "cf7f1933",

  // DISTRIBUTION
  DISTRIBUTION_ACCESS = "b12405b6",

  // REPORTING
  REPORTING_ACCESS = "5db47775",
}

export const enum HashedDynamicPermission {
  // MULTI ORG ACCESS
  MULTI_ORG_ACCESS = "a9b67725",

  // LABS
  LABS_APP_ACCESS = "297b9afc",
}

export const enum HashedModuleRole {
  ORGS_USERS = "3714a354",
  ORGS_USERS_INVITE = "848357a7",

  LICENSES = "cc2e1a4d",
  LICENSES_COMMERCIAL = "c23a1aab",
  LICENSES_LIBRARY_ALL = "9a7d0724",

  COMMERCIAL_SUPPLY_CHAIN = "d7f67587",

  MUSIC = "3de271c4",
  MUSIC_ADAPTIVE_MUSIC = "d03471a8",
  MUSIC_COMMERCIAL_MUSIC = "ead7854e",
  MUSIC_DOWNLOADS = "7ca944d9",
  MUSIC_STREAM_ONLY = "7ec071fb",
  MUSIC_CHARTS = "f4fb26a1",
  MUSIC_BRIEF_SEARCH = "dfc00b67",
  MUSIC_SOUND_EFFECTS_TAB = "a6bb33ee",
  MUSIC_NATURAL_LANGUAGE_TOGGLE = "6712762f",

  MEASUREMENT = "6e7551ef",

  DEMO = "3b6b6446",

  RESOURCES = "246eeabc",

  SOCIAL_CLEARANCES = "93dc6f34",
  DISTRIBUTION = "fa50365f",
}
